import { RootState } from "../Store";

export const SELECT_BANK_LIST_ACTIVE = (state: RootState) =>
  state.banksSlice.BANKS_ACTIVE;

export const SELECT_BANK_LIST_ARCHIVE = (state: RootState) =>
  state.banksSlice.BANKS_ARCHIVE;

export const SELECT_BANK = (state: RootState) => state.banksSlice.SELECTED_BANK;

export const SELECT_FORM_BANK_DISABLE = (state: RootState) =>
  state.banksSlice.BANK_FORM.BANK_FORM_DISABLED;

export const SELECT_FORM_BANK_INITIAL = (state: RootState) =>
  state.banksSlice.BANK_FORM.BANK_FORM_INITIAL;

export const SELECT_FORM_BANK_TYPE = (state: RootState) =>
  state.banksSlice.BANK_FORM.BANK_FORM_TYPE;
